import 'core-js'
import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import App from './App';
import './index.css';


const target= document.getElementById('root');

ReactDOM.render( <App/>, target )

registerServiceWorker();



// WEBPACK FOOTER //
// src/index.js